// Platform-owned control metadata; contains no customer prompts or model-call authority.
import { IsoDateTime,Uuid } from "@secretaa/http-contract";
import { z } from "zod";
const Version=z.number().int().positive().max(Number.MAX_SAFE_INTEGER);
const Key=z.string().regex(/^[a-z][a-z0-9_.-]{0,95}$/);
export const Ref=z.object({id:Uuid,version:Version}).strict();
export const Scope=z.object({workspaceId:Uuid,projectId:Uuid.nullable()}).strict();
const Identity={schemaVersion:z.literal(1),id:Uuid,version:Version,scope:Scope};
export const ModelProfileClass=z.enum(["FAST","BALANCED","REASONING","CODING","VISION"]);
export const ModelProfileRegistryVersion = z.object({ ...Identity, key: Key, profileClass: ModelProfileClass,
  requiredFeatures: z.array(z.enum(["TEXT", "TOOLS", "STRUCTURED_OUTPUT", "VISION", "STREAMING"])).min(1).max(5),
  minContextTokens: z.number().int().positive(), maxOutputTokens: z.number().int().positive(),
  qualityPolicyRef: Ref, benchmarkSnapshotRef: Ref, dataPolicyRef: Ref, routingPolicyRef: Ref,
}).strict();
/** Control artifact only; actual provider/model identifiers never go in WorkPlan/AIProcessingSpec. */
export const ModelCatalogSnapshot = z.object({ id: Uuid, version: Version, capturedAt: IsoDateTime, expiresAt: IsoDateTime,
  entries: z.array(z.object({ provider: Key, modelId: z.string().min(1).max(240), available: z.boolean(),
    features: z.array(z.enum(["TEXT", "TOOLS", "STRUCTURED_OUTPUT", "VISION", "STREAMING"])).max(5), contextTokens: z.number().int().positive(),
    priceSnapshotRef: Ref, dataHandlingPolicyRef: Ref, benchmarkResultRef: Ref,
  }).strict()).min(1).max(2048),
}).strict().refine(s => Date.parse(s.expiresAt) > Date.parse(s.capturedAt), "CATALOG_EXPIRY_INVALID");
export const CONTRACT_VERSION="1.0.0";
